import React, { useEffect, useState } from 'react';
import { BsSpeedometer } from 'react-icons/bs';
import { locales } from '../../../translations/locales';
import ButtonReturnMod from '../configuration/ButtonReturnMod';

const MenuAssignments = (props) => {
    const { ModuleRP, locale, theme, setActivePage, activePage, data, assignment, setAssignment } = props;

    const [select, setSelect] = useState(false);

    useEffect(() => {
        if (data.assignments.length > 0 && !assignment) {
            setAssignment(data.assignments[0].id);
        }
    }, [data]);

    return (
        <aside className={`menuConfiguration ${theme === 'DARK' ? 'text-light menu-bg-dark' : 'text-dark menu-bg-light'}`}>
            <hr className={`m-0 mb-1 bg-secondary`} />
            <div className="text-center text-secondary">
                <ButtonReturnMod
                    loadGame={ModuleRP.loadGame}
                    theme={theme}
                    locale={locale}
                />
                <>
                    {ModuleRP.userName}
                </>
            </div>
            <hr className={`m-1 bg-secondary`} />
            {
                data.assignments.length === 0 ? <div className='alert alert-danger'>
                    <h5 className='alert-heading'>{locales[locale].assignments.noAssignment}</h5>
                </div> :
                    <div>
                        <h5
                            className={`text-center ${theme === 'DARK' ? 'text-light' : 'text-dark'} cursor-pointer`}
                            onClick={() => setSelect(!select)}
                        >
                            {data.assignments.find((e) => e.id === assignment)?.name}
                        </h5>
                        {
                            select ? <select
                                className={`form-control form-control-sm ${theme === 'DARK' ? 'bg-dark text-light' : 'bg-light text-dark'}`}
                                onChange={(e) => {
                                    setAssignment(e.target.value);
                                    setSelect(false);
                                }}
                            >
                                <option value=''>{locales[locale].assignments.selectAssignment}</option>
                                {
                                    data.assignments.map((e, i) => {
                                        return (
                                            <option key={i} value={e.id}>{e.name}</option>
                                        );
                                    })
                                }
                            </select> : ''
                        }
                        <ul className="nav flex-column text-center">
                            <li
                                className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'Home' ? 'bg-primary text-light' : ''}`}
                                onClick={() => setActivePage('Home')}
                            >
                                <span><BsSpeedometer className='mb-1' /> {locales[locale].assignments.home}</span>
                            </li>
                            <li
                                className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'Planning' ? 'bg-primary text-light' : ''}`}
                                onClick={() => setActivePage('Planning')}
                            >
                                <span><BsSpeedometer className='mb-1' /> {locales[locale].assignments.planning}</span>
                            </li>
                        </ul>
                    </div>
            }
        </aside>
    );
};

export default MenuAssignments;
